import { cn } from "@/lib/utils";
import { formatTagLabel, type TagFilter } from "../../lib/modelTags";

function TagChip({
  active,
  onClick,
  label,
  count,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  count: number;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider transition-colors",
        active
          ? "bg-healing-100 text-sands-800"
          : "bg-sands-50 text-sands-500 hover:bg-sands-100 hover:text-sands-700",
      )}
    >
      {label}
      <span className="ml-1 tabular-nums text-sands-400">{count}</span>
    </button>
  );
}

export function ModelTagChips({
  tag,
  onTagChange,
  totalCount,
  availableTags,
  tagCounts,
  resultCount,
  resultSourceCount,
}: {
  tag: TagFilter;
  onTagChange: (next: TagFilter) => void;
  totalCount: number;
  availableTags: readonly string[];
  tagCounts: ReadonlyMap<string, number>;
  resultCount: number;
  resultSourceCount: number;
}) {
  if (totalCount === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1">
      <TagChip
        active={tag === "all"}
        onClick={() => onTagChange("all")}
        label="All"
        count={totalCount}
      />
      {availableTags.map((id) => (
        <TagChip
          key={id}
          active={tag === id}
          onClick={() => onTagChange(id)}
          label={formatTagLabel(id)}
          count={tagCounts.get(id.toLowerCase()) ?? 0}
        />
      ))}
      <span className="ml-auto text-[10px] tabular-nums text-sands-400">
        {resultCount} of {resultSourceCount}
      </span>
    </div>
  );
}
